import { ExternalLink, Layers } from 'lucide-react'
import { Link } from 'react-router'

import { Checkbox } from '@/components/ui/checkbox'
import { memoPath } from '@/routes/paths'

import type { SimilarCardsGate } from './useSimilarCardsGate'

/** 似ているカードがあるときの知らせ（開いて確かめる・新しいカードからつなぐ） */
export const SimilarCardsNotice = ({ gate }: { gate: SimilarCardsGate }) => {
  if (!gate.similar || gate.similar.length === 0) return null
  return (
    <div className="space-y-1.5 rounded-md border border-amber-500/40 bg-amber-500/10 p-2.5">
      <p className="flex items-center gap-1.5 text-xs font-semibold text-amber-700 dark:text-amber-300">
        <Layers className="size-3.5" />
        似ているカードがあります
      </p>
      <ul className="space-y-1">
        {gate.similar.map((card) => (
          <li key={card.memo_id} className="flex items-start gap-2 text-xs">
            <Checkbox
              aria-label={`「${card.title}」とつなぐ`}
              checked={gate.linkIds.includes(card.memo_id)}
              onCheckedChange={() => gate.toggleLink(card.memo_id)}
              className="mt-0.5"
            />
            <div className="min-w-0 flex-1">
              <p className="truncate font-medium">{card.title}</p>
              {card.snippet && <p className="line-clamp-2 text-muted-foreground">{card.snippet}</p>}
            </div>
            <Link
              to={memoPath(card.memo_id)}
              target="_blank"
              className="flex shrink-0 items-center gap-0.5 text-primary"
            >
              <ExternalLink className="size-3" />
              開く
            </Link>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-muted-foreground">
        チェックしたカードは、新しいカードの末尾にリンクでつなぎます。もう一度押すとそのまま作ります
      </p>
    </div>
  )
}
